export default "__VITE_PUBLIC_ASSET__70e3766d__"